
export const capitalize = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getTrimmedText = (text: any) => {
	if (!text || typeof text !== 'string') {
		return text;
	}
	return text.trim();
};

/**
 * Calculates the optimal font size for mode labels based on their character length
 * to prevent text overflow in circular UI components.
 *
 * @param {string} text - The mode label text to measure.
 * @returns {string} The calculated font size in pixels (e.g., "14px").
 */
export const getModeFontSize = (text: string) => {
  if (!text) return '15px';
  const length = text.length;
  if (length > 15) return '10px';
  if (length > 12) return '11px';
  if (length > 10) return '12px';
  if (length >= 8) return '13px';
  if (length >= 4) return '14px';
  return '15px';
};
